module.exports = __webpack_public_path__ + "img/bg10.b610d791.jpg";